export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Measures/GPmeasuresOpen.png?f0d9aa624764e1c62b86468faa8509d9";